import { render, staticRenderFns } from "./SPRStars.vue?vue&type=template&id=17868892"
import script from "./SPRStars.vue?vue&type=script&lang=js"
export * from "./SPRStars.vue?vue&type=script&lang=js"
import style0 from "./SPRStars.vue?vue&type=style&index=0&id=17868892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports